<div class="h-screen w-screen ambient ambient-blue relative overflow-y-auto">
  <div class="min-h-full flex flex-col items-center">
    <div class="flex-1 min-h-0 w-full flex flex-col items-center justify-end">
      <img [src]="branding.logoSrc" alt="Logo" class="h-10 w-auto mt-4 mb-8 shrink-0">
    </div>
    <div class="shrink-0 bg-surface-bright rounded-lg px-6 md:px-8 py-8 md:py-10 flex flex-col max-w-[408px]">
      <ng-container *ngIf="!recoverMode">
        <h2 class="headline-large text-primary mb-1" *ngIf="!mfaChallenge">{{ 'Welcome back!' | translate }}</h2>
        <p class="body-large text-inverse-surface mb-8" *ngIf="!mfaChallenge">
          {{ 'Please enter your login details below' | translate }}</p>
        <div *ngIf="mfaChallenge" class="mb-8 space-y-6 flex-1">
          <ng-container *ngIf="!mfaExhausted">
            <div class="space-y-2">
              <h2 class="headline-large text-primary">{{ 'Approve Login request' | translate }}</h2>
              <p class="body-large text-inverse-surface">
                {{ (mfaChallenge === 'verify-email'
                    ? 'Please enter the verification code sent to your email'
                    : 'Please enter the verification code sent to your phone') | translate }}
              </p>
            </div>
            
            <div class="space-y-4">
              <div class="flex gap-2 w-full">
                <input #digit1 type="text" maxlength="1" placeholder="0"
                  class="flex-1 w-[50px] min-h-[64px] rounded-lg border border-outline-variant bg-surface-bright text-center text-[48px] leading-[60px] tracking-[-0.96px] font-medium text-on-surface-variant focus:border-primary focus:outline-none placeholder:text-on-surface-variant placeholder:opacity-50 caret-transparent"
                  [(ngModel)]="verificationDigits[0]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onDigitInput($event, 0)"
                  (keydown)="onDigitKeyDown($event, 0)"
                  (paste)="onPaste($event)" />
                <input #digit2 type="text" maxlength="1" placeholder="0"
                  class="flex-1 w-[50px] min-h-[64px] rounded-lg border border-outline-variant bg-surface-bright text-center text-[48px] leading-[60px] tracking-[-0.96px] font-medium text-on-surface-variant focus:border-primary focus:outline-none placeholder:text-on-surface-variant placeholder:opacity-50 caret-transparent"
                  [(ngModel)]="verificationDigits[1]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onDigitInput($event, 1)"
                  (keydown)="onDigitKeyDown($event, 1)" />
                <input #digit3 type="text" maxlength="1" placeholder="0"
                  class="flex-1 w-[50px] min-h-[64px] rounded-lg border border-outline-variant bg-surface-bright text-center text-[48px] leading-[60px] tracking-[-0.96px] font-medium text-on-surface-variant focus:border-primary focus:outline-none placeholder:text-on-surface-variant placeholder:opacity-50 caret-transparent"
                  [(ngModel)]="verificationDigits[2]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onDigitInput($event, 2)"
                  (keydown)="onDigitKeyDown($event, 2)" />
                <input #digit4 type="text" maxlength="1" placeholder="0"
                  class="flex-1 w-[50px] min-h-[64px] rounded-lg border border-outline-variant bg-surface-bright text-center text-[48px] leading-[60px] tracking-[-0.96px] font-medium text-on-surface-variant focus:border-primary focus:outline-none placeholder:text-on-surface-variant placeholder:opacity-50 caret-transparent"
                  [(ngModel)]="verificationDigits[3]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onDigitInput($event, 3)"
                  (keydown)="onDigitKeyDown($event, 3)" />
                <input #digit5 type="text" maxlength="1" placeholder="0"
                  class="flex-1 w-[50px] min-h-[64px] rounded-lg border border-outline-variant bg-surface-bright text-center text-[48px] leading-[60px] tracking-[-0.96px] font-medium text-on-surface-variant focus:border-primary focus:outline-none placeholder:text-on-surface-variant placeholder:opacity-50 caret-transparent"
                  [(ngModel)]="verificationDigits[4]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onDigitInput($event, 4)"
                  (keydown)="onDigitKeyDown($event, 4)" />
                <input #digit6 type="text" maxlength="1" placeholder="0"
                  class="flex-1 w-[50px] min-h-[64px] rounded-lg border border-outline-variant bg-surface-bright text-center text-[48px] leading-[60px] tracking-[-0.96px] font-medium text-on-surface-variant focus:border-primary focus:outline-none placeholder:text-on-surface-variant placeholder:opacity-50 caret-transparent"
                  [(ngModel)]="verificationDigits[5]"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onDigitInput($event, 5)"
                  (keydown)="onDigitKeyDown($event, 5)" />
              </div>
              <div *ngIf="verificationError" class="label-medium text-error text-center">{{ verificationError }}</div>
            </div>
          </ng-container>
          <div class="flex flex-col gap-6 items-center" *ngIf="mfaExhausted">
            <div class="bg-primary-container border border-primary-container rounded-full p-3 flex items-center justify-center">
              <mat-icon class="text-on-surface !text-[40px] !w-10 !h-10 material-symbols-outlined">lock</mat-icon>
            </div>
            <div class="headline-small text-primary text-center">
              {{ 'No more methods available' | translate }}
            </div>
            <p class="body-large text-inverse-surface text-center">
              {{ "You've tried all available options. To continue, please" | translate }}
              <a [href]="supportUrl" target="_blank" class="text-primary underline">{{ 'contact support' | translate }}</a>
            </p>
          </div>
        </div>
        <button *ngIf="mfaExhausted" type="button" mat-stroked-button class="w-full mt-28" (click)="resetToLogin()">
          <span>{{ 'Go back' | translate }}</span>
        </button>
        <form #loginForm="ngForm" [formGroup]="authForm" (ngSubmit)="onSubmit()">
          <div class="mb-4 flex flex-col" *ngIf="!mfaChallenge">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'Email address' | translate }}</mat-label>
              <input matInput type="email" formControlName="email" data-testid="login-email-input" />
              <mat-error *ngIf="authForm.get('email')?.errors?.['email']">{{ 'Please enter a valid email address' | translate }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'Password' | translate }}</mat-label>
              <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" (keydown.space)="$event.preventDefault()" />
              <button matIconButton type="button" matSuffix (click)="hide = !hide" class="mr-4 cursor-pointer">
                <mat-icon svgIcon="{{hide ? 'eye_closed' : 'eye_opened'}}"></mat-icon>
              </button>
              <mat-error *ngIf="authForm.get('password')?.errors?.['required']">{{ 'Password is required' | translate }}</mat-error>
            </mat-form-field>
            <div *ngIf="genericError" class="label-medium text-error text-center mb-4">{{ genericError }}</div>
            <div class="label-medium text-on-surface-variant w-full text-center">
              {{ 'Forgot your password?' | translate }} <a href="#" (click)="openRecover($event)"
                class="text-primary underline hover:opacity-80"
                [class.pointer-events-none]="isLoading() !== null"
                [class.opacity-50]="isLoading() !== null"
                [attr.aria-disabled]="isLoading() !== null">{{ 'Click here to reset' | translate }}</a>
            </div>
          </div>

          <div class="space-y-4">
            <button *ngIf="!mfaExhausted" type="submit" mat-flat-button class="w-full flex"
              [disabled]="( !authForm.valid && !mfaChallenge ) || isLoading() !== null || (mfaChallenge && verificationCode.length < 6)">
              <app-loading-spinner [loading]="isLoading() !== null" [diameter]="20">
                {{ isLoading() !== null ? (mfaChallenge ? ('Verifying...' | translate) : ('Logging in...' | translate)) : (mfaChallenge ?
                  ('Login' | translate) : ('Login' | translate)) }}
              </app-loading-spinner>
            </button>

            <button *ngIf="mfaChallenge && !mfaExhausted" type="button" mat-stroked-button class="w-full mt-4" (click)="tryAnotherWay()">
              <span>{{ 'Try another way' | translate }}</span>
            </button>

            <div class="border-t border-[var(--color-surface-container)]" *ngIf="!mfaChallenge"></div>

            <button *ngIf="!mfaChallenge" type="button" mat-stroked-button class="w-full"
              [disabled]="isLoading() !== null" (click)="onSsoLogin('SSO')">
              <mat-icon>key</mat-icon>
              <span>{{ 'Login with SSO' | translate }}</span>
            </button>

            <button *ngIf="!mfaChallenge" type="button" mat-stroked-button class="w-full"
              [disabled]="isLoading() !== null" (click)="onSsoLogin('azure')">
              <span class="flex items-center gap-2">
                <span class="grid grid-cols-2 gap-[1px] h-[18px]">
                  <span class="w-[8.5px] h-[8.5px] bg-[#F0512E]"></span>
                  <span class="w-[8.5px] h-[8.5px] bg-[#81B922]"></span>
                  <span class="w-[8.5px] h-[8.5px] bg-[#1BA6EC]"></span>
                  <span class="w-[8.5px] h-[8.5px] bg-[#FEB82C]"></span>
                </span>
                <span>{{ 'Login with Microsoft' | translate }}</span>
              </span>
            </button>

            <p *ngIf="!mfaExhausted" class="label-medium text-on-surface-variant text-center">{{ 'Having trouble logging in?' | translate }} 
              <a [href]="supportUrl" target="_blank" class="text-primary underline cursor-pointer">{{ 'Contact support' | translate }}</a></p>
          </div>
        </form>
      </ng-container>

      <ng-container *ngIf="recoverMode">
        <ng-container *ngIf="expiredPasswordMode; else recoverHeader">
          <h2 class="headline-large text-primary mb-2">{{ 'Reset your password' | translate }}</h2>
          <p class="body-large text-inverse-surface mb-10">
            {{ 'Your password has expired. Please create a new one to continue' | translate }}
          </p>
        </ng-container>
        <ng-template #recoverHeader>
          <h2 class="headline-large text-primary mb-2">{{ 'Recover your account' | translate }}</h2>
          <p class="body-large text-inverse-surface mb-10" *ngIf="recoverStage === 'email'">{{ 'Please enter your email address below' | translate }}</p>
          <p class="body-large text-inverse-surface mb-10" *ngIf="recoverStage === 'code'">
            {{ 'If your account exists, an email and an sms were sent for account recovery' | translate }}
          </p>
          <p class="body-large text-inverse-surface mb-10" *ngIf="recoverStage === 'password'">
            {{ 'Insert a new password to your T-Pro account' | translate }}
          </p>
          <p class="label-medium text-on-surface-variant mb-4" *ngIf="recoverStage === 'password' && expiredPasswordMessage">
            {{ expiredPasswordMessage }}
          </p>
        </ng-template>

        <form [formGroup]="recoverForm!" (ngSubmit)="onRecover()" class="space-y-1" *ngIf="recoverStage !== 'password'">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'Email' | translate }}</mat-label>
            <input matInput type="email" formControlName="email" placeholder="{{ 'Email*' | translate }}" data-testid="recovery-email-input" />
            <mat-error
              *ngIf="recoverForm?.get('email')?.hasError('required') && (recoverForm?.get('email')?.dirty || recoverForm?.get('email')?.touched)">{{ 'Email is required' | translate }}</mat-error>
            <mat-error
              *ngIf="recoverForm?.get('email')?.hasError('email') && (recoverForm?.get('email')?.dirty || recoverForm?.get('email')?.touched)">{{ 'Please enter a valid email address' | translate }}</mat-error>
          </mat-form-field>

          <div *ngIf="emailError && recoverStage === 'email'" class="label-medium text-error mb-2">{{ emailError }}</div>

          <ng-container *ngIf="recoverStage === 'code'">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ 'Code' | translate }}</mat-label>
              <input matInput type="text" inputmode="numeric" formControlName="code" placeholder="{{ 'Code*' | translate }}" (input)="onRecoveryCodeInput($event)" />
              <mat-error *ngIf="recoverForm?.get('code')?.hasError('invalidCode')">{{ codeError ? codeError : ('Invalid verification code' | translate) }}</mat-error>
              <mat-error
                *ngIf="recoverForm?.get('code')?.hasError('required') && (recoverForm?.get('code')?.dirty || recoverForm?.get('code')?.touched)">{{ 'Code is required' | translate }}</mat-error>
              <mat-error
                *ngIf="recoverForm?.get('code')?.hasError('minlength') && (recoverForm?.get('code')?.dirty || recoverForm?.get('code')?.touched)">{{ 'Code must be 6 digits' | translate }}</mat-error>
            </mat-form-field>
          </ng-container>

          <div class="flex items-center justify-between gap-6 pt-4">
            <button type="button" mat-stroked-button class="w-1/2" (click)="closeRecover()">
              <span>{{ 'Go back' | translate }}</span>
            </button>
            <button type="submit" mat-flat-button color="primary" class="w-1/2"
              [disabled]="isLoading() !== null || (recoverStage === 'email' ? recoverForm?.get('email')?.invalid : recoverForm?.get('code')?.invalid)">
              <app-loading-spinner [loading]="isLoading() !== null" [diameter]="20">
                {{ recoverStage === 'email' ? ('Continue' | translate) : ('Verify' | translate) }}
              </app-loading-spinner>
            </button>
          </div>
        </form>

        <form [formGroup]="resetPasswordHelper!.getForm()" (ngSubmit)="onPasswordReset()" class="space-y-1" *ngIf="recoverStage === 'password' && resetPasswordHelper">
          <div class="mb-2">
            <app-new-password
              #newPassword
              [control]="resetPasswordHelper.getForm().get('newPassword')"
              [passwordPattern]="resetPasswordHelper.getPattern()"
              [confirmPasswordValue]="resetPasswordHelper.getForm().get('confirmPassword')?.value || ''"
              [label]="'New password' | translate"
              [placeholder]="'Enter new password' | translate">
            </app-new-password>
          </div>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'Confirm new password' | translate }}</mat-label>
            <input 
              matInput 
              [type]="hideConfirmPassword ? 'password' : 'text'"
              formControlName="confirmPassword" 
              [placeholder]="'Re-enter password' | translate"
            />
            <button mat-icon-button type="button" matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" class="text-on-surface-variant">
              <mat-icon [svgIcon]="hideConfirmPassword ? 'eye_closed' : 'eye_opened'"></mat-icon>
            </button>
            <mat-error *ngIf="resetPasswordHelper.getForm().get('confirmPassword')?.hasError('required')">
              {{ 'Please confirm your password' | translate }}
            </mat-error>
            <mat-error *ngIf="resetPasswordHelper.getForm().get('confirmPassword')?.hasError('passwordMismatch')">
              {{ 'Passwords do not match' | translate }}
            </mat-error>
          </mat-form-field>


          <div *ngIf="genericError" class="label-medium text-error text-center mb-2">{{ genericError }}</div>

          <div class="flex items-center justify-between gap-4 pt-4">
            <button *ngIf="!expiredPasswordMode" type="button" mat-stroked-button class="w-1/2" (click)="closeRecover()">
              <span>{{ 'Go back' | translate }}</span>
            </button>
            <button type="submit" mat-flat-button color="primary" [ngClass]="expiredPasswordMode ? 'w-full' : 'w-1/2 !px-3'"
              [disabled]="!resetPasswordHelper.getForm().valid || isLoading() !== null">
              <app-loading-spinner [loading]="isLoading() !== null" [diameter]="20">
                {{ 'Change password' | translate }}
              </app-loading-spinner>
            </button>
          </div>
        </form>
      </ng-container>
    </div>
    <div class="flex-1 min-h-0 w-full flex flex-col items-center">
      <div class="h-12">
        <p
        class="mt-4 shrink-0 label-small text-white/60 text-center"
        [class.cursor-pointer]="developmentModeEnabled"
        [attr.title]="developmentModeEnabled ? ('Double click to toggle development mode' | translate) : null"
        (dblclick)="onVersionDoubleClick()"
        >
          {{ 'Version' | translate }}: {{ versionDisplay }}
        </p>
      </div>
      <div *ngIf="branding.showPoweredByTpro" class="flex flex-col items-center shrink-0">
        <span class="label-small uppercase tracking-[0.15em] text-white/60">{{ 'powered by' | translate }}</span>
        <img src="assets/logo_grey.png" alt="T-Pro" class="h-7 w-auto mt-1.5" />
      </div>
    </div>
  </div>
</div>